import { ExportToExcel } from '@/services/excel/generator/excelGenerator';
import ExportExcel from '@/services/excel/generator/exportExcel';
import SheetExcel from '@/services/excel/generator/sheetExcel';
import ColumnExcel from '@/services/excel/generator/columnExcel';

export const columns = [
  new ColumnExcel('Code', 'code', true),
  new ColumnExcel('Nom commercial', 'nomCommercial', true),
  new ColumnExcel('Nom Juridique', 'nomJuridique'),
  new ColumnExcel('Prospect', 'prospect'),
  new ColumnExcel('Actif', 'archive'),
  new ColumnExcel('Intitulé1', 'adressePostale.intitule1', false, 100),
  new ColumnExcel('Intitulé2', 'adressePostale.intitule2', false, 100),
  new ColumnExcel('Intitulé3', 'adressePostale.intitule3', false, 100),
  new ColumnExcel('Adresse1', 'adressePostale.adresse1', false, 100),
  new ColumnExcel('Adresse2', 'adressePostale.adresse2', false, 100),
  new ColumnExcel('Adresse3', 'adressePostale.adresse3', false, 100),
  new ColumnExcel('CP', 'adressePostale.codePostal', false, 100),
  new ColumnExcel('Ville', 'adressePostale.ville', false, 100),
  new ColumnExcel('Pays', 'adressePostale.pays', false, 100),
  new ColumnExcel('Intitulé1', 'adresseFacturation.intitule1', false, 100),
  new ColumnExcel('Intitulé2', 'adresseFacturation.intitule2', false, 100),
  new ColumnExcel('Intitulé3', 'adresseFacturation.intitule3', false, 100),
  new ColumnExcel('Adresse1', 'adresseFacturation.adresse1', false, 100),
  new ColumnExcel('Adresse2', 'adresseFacturation.adresse2', false, 100),
  new ColumnExcel('Adresse3', 'adresseFacturation.adresse3', false, 100),
  new ColumnExcel('CP', 'adresseFacturation.codePostal', false, 100),
  new ColumnExcel('Ville', 'adresseFacturation.ville', false, 100),
  new ColumnExcel('Pays', 'adresseFacturation.pays', false, 100),
  new ColumnExcel('Téléphone', 'telephone'),
  new ColumnExcel('Portable', 'portable'),
  new ColumnExcel('Email', 'email'),
  new ColumnExcel('Compte Comptable', 'compteComptable'),
  new ColumnExcel('Mode de réglement', 'modeReglement'),
  new ColumnExcel('Délai de règlement', 'delaiReglement'),
  new ColumnExcel('Siret', 'siret'),
  new ColumnExcel('TVA Intracommunautaire', 'tvaIntracommunautaire'),
  new ColumnExcel('Libellé Banque', 'rib.banque'),
  new ColumnExcel('Titulaire compte', 'rib.titulaire'),
  new ColumnExcel('IBAN', 'rib.iban'),
  new ColumnExcel('BIC', 'rib.bic'),
  new ColumnExcel('Commentaire interne', 'commentairesInternes'),
  new ColumnExcel('Typologie (PointVente, Enseigne, Groupe)', 'typologie', true),
  new ColumnExcel('Marques', 'tiersMarques'),
  new ColumnExcel('Lien Enseigne', 'enseigneId'),
  new ColumnExcel('Lien Groupe', 'groupeId'),
];

export function templateConfig(data) {
  return new ExportExcel(
    'TemplateClient.xlsx',
    [
      new SheetExcel(
        'Clients',
        columns,
        data,
        { skipHeader: false },
      ),
    ],
  );
}

export function generatedTemplateClient() {
  const exemple = {
    code: 'C1994',
    nomCommercial: 'Client & Cie',
    adressePostale: {
      intitule1: 'Client & Cie',
      adresse1: '9 rue de Paris',
      codePostal: '59000',
      ville: 'Lille',
      pays: 'France',
    },
    typologie: 'Aucun',
    tiersMarques: '"Auchan","Mc Donald"',
  };
  const config = templateConfig([exemple]);
  ExportToExcel(config);
}
